
import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Confidentiality_table from "./confidentiality_table/Confidentiality_table";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Confidentiality() {

  const permissions = useSelector((state) => state.auth.permissions);
  
  const haveReadPermission = permissions?.includes(FixIDS.confidentiality.List);

  return (
    <>
      <section className="Imperiality">
        <div className="back_div">
          <Common_Back_Btn backText="Confidentiality" />
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <Confidentiality_table />}
        </div>
      </section>
    </>
  );
}

export default Confidentiality;
